import { css } from 'lit';

// language=CSS
export const styles =
    css`
        :host {
            height: 100%;
            width: 100%;
        }
    `;
